<template>
  <div>
    <search-supplier-esim @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findEsimSupplierEsims } from '@/api/esim_supplier'
import Pagination from '@/components/Pagination'
import SearchSupplierEsim from '@/views/esims/supplier/Search'

export default {
  name: 'SupplierEsimList',
  components: {
    Pagination,
    SearchSupplierEsim
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      columns: [
        {
          title: 'EID',
          dataIndex: 'eid',
          width: 220,
          fixed: 'left'
        },
        {
          title: '卡板类型',
          dataIndex: 'card_type_name',
          width: 120
        },
        {
          title: '卡板规格',
          dataIndex: 'card_shape_name',
          width: 120
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '所属客户',
          dataIndex: 'agent_name',
          width: 160
        },
        {
          title: '订单号',
          dataIndex: 'order_no',
          width: 160
        }
      ]
    }
  },
  computed: {
    esimSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findEsimSupplierEsims(this.esimSupplierId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
